import { Injectable, ViewContainerRef } from '@angular/core';
import {Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { ConversationContact as ConvContact } from 'app/clmtlk/shared/model/conversationContacts';
import { Observable } from 'rxjs/Observable';
import { BlockUIService } from 'ng-block-ui';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { Contact } from 'app/clmtlk/shared//model/conversationContacts';
import * as ServerObj from 'app/clmtlk/shared/model/serverObjects';

import { Action } from 'app/clmtlk/shared/model/action';
import { ToastrService } from 'ngx-toastr';



@Injectable()
export class InboxResolver implements Resolve<ConvContact[]> {

    constructor(private clmtlkService: ClmtlkService,
        private router: Router,
        private blockUIService: BlockUIService,
        private clmtlkSessionService: ClmtlkSessionService,
        private toastrService: ToastrService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ConvContact[] | Observable<ConvContact[]> | Promise<ConvContact[]> {

        const token: string = route.queryParamMap.get('a');
        if (token) {
            this.clmtlkSessionService.authToken = token;
        }

        const srcId: string = route.queryParamMap.get('srcId');
        if ( srcId ) {
            this.clmtlkSessionService.srcId = srcId;
        }
        const skipOverview: string = route.queryParamMap.get('skipOverview');
        if ( skipOverview ) {
            this.clmtlkSessionService.setSkipOverview(skipOverview=="true");
        }
        //console.info("clmtlkSessionService", this.clmtlkSessionService);
        return this.refreshInbox();
    }


    refreshInbox(): Observable<ConvContact[]> {
        this.blockUIService.start('main', 'Loading initial Data... please wait');
        return this.clmtlkService.initializeMainData().map(
            result => this.processData(result)
        ).catch(error => {
            //console.error('Data Initialization failed' + error);
            if ( error.status === '401') {
                this.router.navigateByUrl('/login');
                return Observable.of([]);
            }
            if (this.clmtlkSessionService.getFKScenario()!="threaddetails")
            {
                this.toastrService.error(error, 'Data Initialization failed',
                { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0});
                return Observable.of([]);
            }
        }).finally(() => {
            this.blockUIService.stop('main');
        });
    }

    processData(result) {
       
        const convContacts: ConvContact[] = result;
        if (this.clmtlkSessionService.getFKScenario()=="threaddetails") { 
            const useConv = this.clmtlkService.conversation;
            //console.info("strFKScenario",this.clmtlkSessionService.getFKScenario(),"useConv",useConv);
            this.clmtlkSessionService.setSkipOverview(false);
            //console.info("strFKScenario",this.clmtlkSessionService.getFKScenario());
            this.clmtlkSessionService.setConversationContext(null, useConv, null);
            const conv_id = useConv[0].CONV_ID;
            const thrd_id = useConv[0].conversationThreads.conversationThread[0].THRD_ID;
            console.info("conv_id",conv_id,"thrd_id",thrd_id,"conversationContacts",result,"useConv",useConv,"this.clmtlkSessionService",this.clmtlkSessionService);
            this.blockUIService.stop('main');
            this.router.navigate(['/convo', conv_id, 'thread', thrd_id]);    
        }
     
        // Set Loggedin Contact to Session
        // Take loggedInContract from any convContact and add to Session
        this.setLoggedInUser(convContacts[0]);

        // Filter out the Empty Messages and return result to inbox view
        // tslint:disable-next-line:prefer-const
        let inboxConvContacts: ConvContact[] = [];
        convContacts.forEach((convContact: ConvContact) => {
            if (convContact.messages &&
                convContact.messages.message &&
                convContact.messages.message.length > 0) {
                    inboxConvContacts.push(convContact);
                }
        });
        
        // If Conversation contain any messages, then go to Inbox
        if (inboxConvContacts && inboxConvContacts.length > 0 ||
            this.clmtlkSessionService.loggedInContact.CTC_SRC_CD.toLowerCase() === 'st') {
            return inboxConvContacts;
        }

        
        // If ConvContact found with no Messages, then Create a New Conversation
        // At this time we should have only one item in the ConvContact array.
        const convContact: ConvContact = convContacts[0];
        this.clmtlkSessionService.setConversationContext('NEW_STREAM_CONVERSATION'
            , convContact.conversations.conversation[0]
            , Action.NEWCONVERSATION);
        this.router.navigate(['/message', 'new']);
    }


    setLoggedInUser(conversationContact: ConvContact){
        const conversationContacts: ConvContact[] = conversationContact.loggedInConversationContacts.conversationContact;
        const loggedInConversationContacts = conversationContacts;
        if (loggedInConversationContacts.length > 1 ||
            loggedInConversationContacts.length === 0) {
                console.warn('Logged in Contact is More than one or Empty');
            }

        const loggedUser = loggedInConversationContacts[0];
        loggedUser.CTC_ADDR_TYP_CD = 'frm';
        loggedUser.CTC_IMPRS_NM = null;
        this.clmtlkSessionService.loggedInContact = loggedUser;
        this.clmtlkSessionService.reuseConv = conversationContact.conversations.conversation[0];

        if (conversationContact.conversations.conversation[0]) {
            this.clmtlkSessionService.pinCode = conversationContact.conversations.conversation[0].CONV_SEC_PIN_TXT;
        }

    }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/inbox/shared/inbox-resolver.service.ts